// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Meeting  {
    _originalTypeClassName = "Loom.BO.Meeting";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Meeting.translate = translateService;
}
this.Attachments = [];
this.Attendees = [];
this.Trips = [];
this.Id = null;
this.From = null;
this.To = null;
this.Name = null;
this.Description = null;
this.Status = null;
this.AllDay = false;
this.Type = null;
this.IsVirtual = false;
this.VirtualMeetingLink = null;
this.CreatedOn = null;
this.MeetingMode = null;
this.TimezoneOffset = null;
this.TimezoneCaption = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
From:any;
To:any;
Name:any;
Description:any;
Status:any;
AllDay:any;
Type:any;
IsVirtual:any;
VirtualMeetingLink:any;
CreatedOn:any;
MeetingMode:any;
TimezoneOffset:any;
TimezoneCaption:any;
Project:any;
Location:any;
ProjectReview:any;
CreatedBy:any;
Attachments:any;
Attendees:any;
Trips:any;
static setProject = ($this, value) => {
var oldValue = $this.Project;
$this.Project = value;
if (value != null) {
if (oldValue != null) {
Domain.Project.removeMeetings(oldValue, $this);
}
Domain.Project.addMeetings(value, $this);
}
}
static setLocation = ($this, value) => {
var oldValue = $this.Location;
$this.Location = value;
if (value != null) {
}
}
static setProjectReview = ($this, value) => {
var oldValue = $this.ProjectReview;
$this.ProjectReview = value;
if (value != null) {
if (oldValue != null) {
Domain.ProjectReview.removeMeeting(oldValue, $this);
}
Domain.ProjectReview.addMeeting(value, $this);
}
}
static setCreatedBy = ($this, value) => {
var oldValue = $this.CreatedBy;
$this.CreatedBy = value;
if (value != null) {
}
}
static setAttachments = ($this, items) => {
                if (items == null) items = [];
                if ($this.Attachments == null) $this.Attachments = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Attachments.length > 0) {
                    Domain.Meeting.removeAttachments($this, $this.Attachments[0]);
                }

                Domain.Meeting.addManyAttachments($this, copyItems);
            }
static addManyAttachments = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Meeting.addAttachments($this, items[i]);
                }
            }
static addAttachments = ($this, item) => {
                if ($this.Attachments == null) $this.Attachments = [];
                if (item == null || $this.Attachments.indexOf(item) > -1) return;
                $this.Attachments.push(item);
}
static addRangeAttachments = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Meeting.addAttachments($this, item));
            }
static removeAttachments = ($this, item) => {
                if ($this == null || $this.Attachments == null || $this.Attachments.indexOf(item) === -1) return;
                var _index = $this.Attachments.indexOf(item);
                $this.Attachments.splice(_index, 1);
}
static clearAttachments = ($this) => { $this.Attachments = null; }
static setAttendees = ($this, items) => {
                if (items == null) items = [];
                if ($this.Attendees == null) $this.Attendees = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Attendees.length > 0) {
                    Domain.Meeting.removeAttendees($this, $this.Attendees[0]);
                }

                Domain.Meeting.addManyAttendees($this, copyItems);
            }
static addManyAttendees = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Meeting.addAttendees($this, items[i]);
                }
            }
static addAttendees = ($this, item) => {
                if ($this.Attendees == null) $this.Attendees = [];
                if (item == null || $this.Attendees.indexOf(item) > -1) return;
                $this.Attendees.push(item);
if (item.Meeting != $this) {
Domain.MeetingAttendee.setMeeting(item, $this);
}
}
static addRangeAttendees = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Meeting.addAttendees($this, item));
            }
static removeAttendees = ($this, item) => {
                if ($this == null || $this.Attendees == null || $this.Attendees.indexOf(item) === -1) return;
                var _index = $this.Attendees.indexOf(item);
                $this.Attendees.splice(_index, 1);
item.Meeting = null;
}
static clearAttendees = ($this) => { $this.Attendees = null; }
static setTrips = ($this, items) => {
                if (items == null) items = [];
                if ($this.Trips == null) $this.Trips = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Trips.length > 0) {
                    Domain.Meeting.removeTrips($this, $this.Trips[0]);
                }

                Domain.Meeting.addManyTrips($this, copyItems);
            }
static addManyTrips = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Meeting.addTrips($this, items[i]);
                }
            }
static addTrips = ($this, item) => {
                if ($this.Trips == null) $this.Trips = [];
                if (item == null || $this.Trips.indexOf(item) > -1) return;
                $this.Trips.push(item);
if (item.Meeting != $this) {
Domain.Trip.setMeeting(item, $this);
}
}
static addRangeTrips = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Meeting.addTrips($this, item));
            }
static removeTrips = ($this, item) => {
                if ($this == null || $this.Trips == null || $this.Trips.indexOf(item) === -1) return;
                var _index = $this.Trips.indexOf(item);
                $this.Trips.splice(_index, 1);
item.Meeting = null;
}
static clearTrips = ($this) => { $this.Trips = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}